
const getters = {
  // 审图号
  drawReviewNum: state => state.user.drawReviewNum,
  getUser: state => state.user.user,
  // 全屏展示
  fullFlag: state => state.user.fullFlag,
  // 退出全屏
  logOutFlag: state => state.user.logOutFlag,
  // 控制头部和底部
  commonFlag: state => state.user.commonFlag,
  // 是否点击立即体验登录标识
  pathMainFlag: state => state.user.pathMainFlag,
  // 区分移动或者pc
  isPhoneFlag: state => state.user.isPhoneFlag,
  // 数据权限
  permissions: state => {
    if(state.permission.permissions.length==0){
      const permissionsStr = localStorage.getItem('permissions')
      if(permissionsStr && permissionsStr!='[]' && permissionsStr !='undefined'){
        state.permission.permissions = JSON.parse(permissionsStr)
        return JSON.parse(permissionsStr)
      }
    }
    return state.permission.permissions
  },
  /* 获取用户登录标识*/
  getLoginedFlag: state => {
    if (!state.user.logined) {
      let localLogined = localStorage.getItem('logined');
      if (localLogined == 'true') {
        state.user.logined = true;
        return true;
      } else {
        state.user.logined = false;
        return false;
      }
    }
    return state.user.logined
  },
  // 用户信息
  getUser: state => {
    if (!_.size(state.user.user)) {
      var user = {};
      var u = JSON.parse(window.localStorage.getItem("user"));
      if (u) {
        user = u;
      }
      localStorage.setItem("user", JSON.stringify(user));
      return user;
    }
    return state.user.user
  },
  // 用户AK
  getUserAccessToken: state => {
    if (!state.user.userAKInfo) {
      let localLogined = localStorage.getItem('userAKInfo');
      if (localLogined) {
        state.user.userAKInfo = localLogined;
        return localLogined;
      } else {
        state.user.userAKInfo = '';
        return '';
      }
    }
    return state.user.userAKInfo
  },
  // 用户Ck
  getUserClientToken: state => {
    if (!state.user.userCKInfo) {
      let localLogined = localStorage.getItem('userCKInfo');
      if (localLogined) {
        state.user.userCKInfo = localLogined;
        return localLogined;
      } else {
        state.user.userCKInfo = '';
        return '';
      }
    }
    return state.user.userCKInfo
  },
   // 用户client_id和apikey
   getUserApiInfo: state => {
    if (!_.size(state.user.userApiInfo)) {
      let apiInfo = {};
      let u = JSON.parse(window.localStorage.getItem("userApiInfo"));
      if (u) {
        apiInfo = u;
      }
      localStorage.setItem("userApiInfo", JSON.stringify(apiInfo));
      return apiInfo;
    }
    return state.user.userApiInfo
  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js